import * as Animate from "react-reveal";
import Img1 from "../../../assets/images/png/utiva_people/5.webp";
import Img2 from "../../../assets/images/png/utiva_people/7.webp";
import Img3 from "../../../assets/images/png/utiva_people/9.webp";

const moments = [
  {
    number: "01",
    image: Img1,
    title: "Small teams. Real ownership.",
    desc:
      "You will work close to the problem, make decisions and see how your contribution changes a learner or customer experience.",
  },
  {
    number: "02",
    image: Img2,
    title: "Build close to the learner.",
    desc:
      "Our teams stay connected to the people using what we create, so feedback becomes better programmes, products and outcomes.",
  },
  {
    number: "03",
    image: Img3,
    title: "Grow with ambitious people.",
    desc:
      "Expect generous collaboration, direct communication and teammates who care about doing work that matters.",
  },
];

const CareerLifeSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4" id="life">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Life inside Utiva
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              What it feels like to build here.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Real team moments and the principles that shape the work.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {moments.map((moment) => (
            <Animate.Fade bottom key={moment.number}>
              <div>
                <div
                  className="relative rounded-2xl overflow-hidden mb-5"
                  style={{ height: "220px" }}
                >
                  <img
                    src={moment.image}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <span className="absolute bottom-4 left-4 w-9 h-9 rounded-full bg-secondary text-primary grid place-items-center font-poppins text-sm font-extrabold">
                    {moment.number}
                  </span>
                </div>
                <h3 className="font-poppins font-extrabold text-xl text-primary mb-2.5">
                  {moment.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed pb-5 border-b-2 border-primary">
                  {moment.desc}
                </p>
              </div>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareerLifeSection;
